import { ThemeColorVariable } from '@caspeco/casper-ui-library.base-ui.theme';
const checkedHoverStyleSelector = 'label[data-checked]:not(:active):not([data-disabled]):hover';
const uncheckedHoverStyleSelector = 'label:not([data-checked]):not(:active):not([data-disabled]):not([data-invalid]):hover';
const invalidHoverStyleSelector = 'label[data-invalid]:not([data-checked]):hover';
/**
 * Custom Style Object only for Radio hover styles.
 *
 * Applied here rather than in theme (radio-theme.ts) to enable a set of more advanced hover styles,
 * covering the many different states of the radio-component.
 */
export const hoverStyles = {
    // Target only device that supports hover (excludes thouch screen devices):
    '@media(hover: hover)': {
        // General cursor styles
        'label:not([data-disabled]):hover': {
            cursor: 'pointer',
        },
        'label[data-disabled]:hover': {
            cursor: 'not-allowed',
        },
        // Specifc state hover styles
        [checkedHoverStyleSelector]: {
            '.chakra-radio__control': {
                bg: ThemeColorVariable.AccentHover,
                borderColor: ThemeColorVariable.AccentHover,
                color: ThemeColorVariable.OnAccent,
            },
        },
        [uncheckedHoverStyleSelector]: {
            '.chakra-radio__control': {
                borderColor: ThemeColorVariable.AccentHover,
                color: ThemeColorVariable.OnSurface,
            },
        },
        [invalidHoverStyleSelector]: {
            '.chakra-radio__control': {
                color: ThemeColorVariable.ErrorHover,
                borderColor: ThemeColorVariable.ErrorHover,
            },
        },
    },
};
export const hoverStylesCard = {
    // Target only device that supports hover (excludes thouch screen devices):
    '@media(hover: hover)': {
        // General cursor styles
        'label:not([data-disabled]):hover': {
            cursor: 'pointer',
        },
        'label[data-disabled]:hover': {
            cursor: 'not-allowed',
        },
        // Specifc state hover styles
        [checkedHoverStyleSelector]: {
            '.chakra-radio__control': {
                bg: ThemeColorVariable.AccentHover,
                borderColor: ThemeColorVariable.AccentHover,
                color: ThemeColorVariable.OnAccent,
            },
        },
        [uncheckedHoverStyleSelector]: {
            '.chakra-radio__control': {
                color: ThemeColorVariable.OnSurface,
                background: ThemeColorVariable.AccentHoverAlpha,
            },
        },
        [invalidHoverStyleSelector]: {
            '.chakra-radio__control': {
                color: ThemeColorVariable.ErrorHover,
                borderColor: ThemeColorVariable.ErrorHover,
            },
        },
    },
};
//# sourceMappingURL=radio.hoverstyles.js.map